<div class="page-bg">
  <div class="card">

    <div class="left">
      <img src="/assets/Cover photo.jpg" alt="golf">
    </div>

    <div class="right">
      <div class="brand flex justify-center">
        <img src="/assets/layout/kga-logo.png" alt="logo" width="80px" />
      </div>
      <h5 class="text-center mb-4">Karnataka Golf Association</h5>
      <div class="auth-page">
        <div class="auth-card">
          @if (step === 'memberCode') {
          <div class="fade-in">
            <h2>Sign In</h2>
            <p class="subtitle">Enter your membership id to continue.</p>

            <form (ngSubmit)="submitMemberCode()" #signInForm="ngForm">
              <div class="form-group">
                <label for="memberCode">Membership Id</label>
                <input id="memberCode" name="memberCode" type="text" [(ngModel)]="memberCode" placeholder="e.g. MEM001"
                  required />
                @if (signInForm.submitted && !memberCode) {
                <small class="error-text">Please enter membership id.</small>
                }
              </div>

              <button type="submit" class="btn-primary" [disabled]="isSubmitting">
                {{ isSubmitting ? 'Sending OTP...' : 'Continue' }}
              </button>
            </form>
          </div>
          } @else {
          <div class="fade-in">
            <h2>OTP Verification</h2>
            <p class="subtitle">Enter the 6-digit code sent to your mobile.</p>

            <form (ngSubmit)="submitOtp()" #otpForm="ngForm">
              <div class="form-group">
                <label for="otpInput">6-digit OTP</label>
                <input id="otpInput" name="otp" type="text" inputmode="numeric" maxlength="6" [(ngModel)]="otp"
                  class="otp-input" placeholder="Enter OTP" required />
                @if (otpForm.submitted && (!otp || otp.length !== 6)) {
                <small class="error-text">Please enter a valid 6-digit OTP.</small>
                }
              </div>

              <button type="submit" class="btn-primary" [disabled]="isSubmitting">
                {{ isSubmitting ? 'Verifying...' : 'Verify OTP' }}
              </button>
            </form>

            <!-- <div class="resend-otp">
              @if (resendCooldownSeconds > 0) {
              <span>
                Resend OTP in {{ resendCooldownSeconds }}
                {{ resendCooldownSeconds === 1 ? 'second' : 'seconds' }}
              </span>
              } @else {
              <button type="button" class="privacy-link"
                [disabled]="resendLimitReached || isResendingOtp || isSubmitting" (click)="resendOtp()">
                {{ isResendingOtp ? 'Resending OTP...' : "Resend OTP" }}
              </button>
              }
            </div>

            <button type="button" class="link-back" (click)="backToMemberCode()">
              <span class="icon">←</span>
              <span class="text">Back</span>
            </button> -->

            <div class="otp-actions">

              @if (resendCooldownSeconds > 0) {

              <div class="resend-otp countdown-text">
                Resend OTP in {{ resendCooldownSeconds }}
                {{ resendCooldownSeconds === 1 ? 'second' : 'seconds' }}
              </div>

              } @else {

              <button type="button" class="link-back" (click)="backToMemberCode()">
                <span class="icon">←</span>
                <span class="text">Back</span>
              </button>

              <button type="button" class="privacy-link"
                [disabled]="resendLimitReached || isResendingOtp || isSubmitting" (click)="resendOtp()">
                {{ isResendingOtp ? 'Resending OTP...' : 'Resend OTP' }}
              </button>

              }

            </div>
          </div>
          }
          <!-- @if (errorMessage) {
          <div class="error-container">
            <p class="error">{{ errorMessage }}</p>
          </div>
          } -->
        </div>
      </div>

      <p class="privacy-notice">

        <button type="button" class="privacy-link" (click)="openPrivacyPolicy()">Privacy Policy</button>.
      </p>
    </div>
  </div>
</div>